export default "__VITE_ASSET__DZO$aC5M__"